<template>
  <div class="about">
    <div class="header-box" id="headerBox">
      <layoutHeader :default-bg="'rgba(0,0,0,0.4)'" scroll-bg="#141414"/>

    </div>
    <div class="content">

      <div class="title"></div>

      <div class="tab" id="aboutTab" :class="tabFixed ? 'tab-fixed':''">
        <div class="main-container">
          <template v-for="(item, index) in tabList">
            <div class="item " :class="tabIndex === index ? 'active':''" @click="lookUp(index)">{{ item.name }}</div>
          </template>
        </div>
      </div>


      <div class="company" id="company">
        <div class="left">
          <el-image src="https://ssv-website.oss-cn-shenzhen.aliyuncs.com/mainland/image/company.0630a4a2.png"></el-image>
        </div>
        <div class="right">
          <div class="title">
            <span>公司介绍</span></div>
          <!--          <div class="desc">企业高新技术——</div>-->
          <div class="detail">
            深圳市三维易境科技有限公司是一家专业从事3D产品研发和运营的高新技术企业，专注于3D技术创新、软件开发、内容制作和3D平台运营。目前已获得20多项专利。公司拥有国内外100多项发明专利，致力于在裸眼3D领域深耕细作。<br>
            <br>
            三维易境依托多元化的产业优势，多年来专注于裸眼3D核心技术的研发，利用柱面镜光栅构建了端到端的裸眼3D解决方案。目前拥有全系列裸眼3D产品，可兼容多种3D格式，可广泛应用于各行业，为观众呈现逼真震撼的3D影像。
          </div>
        </div>
      </div>

      <div class="honor" id="honor">
        <div class="title">
          <span>荣誉资质</span></div>
        <div class="list top">
          <div class="swiper-container swiper swiper-no-swiping" id="topSwiper">
            <div class="swiper-wrapper">
              <template v-for="(index) in 12">
                <div class="swiper-slide" :key="index">
                  <img :src="require('@/assets/patent/'+(index+11)+'.png')">
                </div>
              </template>
            </div>
          </div>
        </div>
        <div class="list bottom">
          <div class="swiper-container swiper swiper-no-swiping" id="bottomSwiper">
            <div class="swiper-wrapper">
              <template v-for="(index) in 11">
                <div class="swiper-slide" :key="index">
                  <img :src="require('@/assets/patent/'+(index+22)+'.png')">
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>

      <div class="team" id="team"  style="display: none">
        <div class="title">
          <span>核心团队</span></div>
        <div class="list">
          <div class="item-container">
            <div class="span"></div>
            <div class="item">
              <div class="avatar">
                <el-image
                    src="https://ssv-website.oss-cn-shenzhen.aliyuncs.com/mainland/image/1661175927750_2.png"></el-image>
              </div>
              <div class="name">陈佛林</div>
              <div class="desc">产品总监</div>
              <div class="content">
                先后供职于富士康、腾讯、阿里<br>
                拥有10年的生产制造管理经验<br>
                拥有3D行业软硬件结合产品应用经验<br>
                拥有丰富的产品跨界整合、集成经验
              </div>
            </div>
          </div>
          <div class="item-container ceo">
            <div class="item ">
              <div class="avatar">
                <el-image
                    src="https://ssv-website.oss-cn-shenzhen.aliyuncs.com/mainland/image/1661175904260_1.png"></el-image>
              </div>
              <div class="name">谭杰夫</div>
              <div class="desc">创始人、董事长</div>
              <div class="content">
                深圳市南山区人大代表<br>
                <div class="sub-title">曾任</div>
                <div class="sub-info">
                  <div>阿里云企业事业线</div>
                  <div>总裁</div>
                </div>
                <div class="sub-info">
                  <div>腾讯集团</div>
                  <div>数据中心总规划师</div>
                </div>
                <div class="sub-info">
                  <div>平安集团</div>
                  <div>高级架构师</div>
                </div>
                <div class="sub-title">协会</div>
                <div class="sub-info">
                  <div>深圳市科技文化创新产业促进会</div>
                  <div>联席创会会长</div>
                </div>
                <div class="sub-info">
                  <div>湖北省丹江口市</div>
                  <div>数字经济总规划师</div>
                </div>
                <div>ODCC创始人及第一届主席</div>
                <div>南方科技大学专业学位研究生业界导师</div>
              </div>
            </div>
          </div>
          <div class="item-container">
            <div class="span"></div>
            <div class="item">
              <div class="avatar">
                <el-image
                    src="https://ssv-website.oss-cn-shenzhen.aliyuncs.com/mainland/image/1661175930225_3.png"></el-image>
              </div>
              <div class="name">范安心</div>
              <div class="desc">副总裁</div>
              <div class="content">
                二十多年IT基础架构、云计算运营管理经验<br>
                曾任<br>
                平安科技系统运营部总经理<br>
                平安科技企业经营管理部总经理<br>
                平安科技党委书记
              </div>
            </div>
          </div>
        </div>
        <div class="list bottom-list">
          <div class="span"></div>
          <div class="item-container">
            <div class="item">
              <div class="avatar">
                <el-image
                    src="https://ssv-website.oss-cn-shenzhen.aliyuncs.com/mainland/image/1661175932489_4.png"></el-image>
              </div>
              <div class="name">胡正中</div>
              <div class="desc">CTO</div>
              <div class="content">
                超十年裸眼3D软硬件开发经验<br>
                超四十篇包含中国、日本、美国专利<br>
                主导裸眼3D光学技术<br>
                掌握全球3D产业链技术及资源
              </div>
            </div>
          </div>


          <div class="span"></div>

          <div class="item-container">
            <div class="item">
              <div class="avatar">
                <el-image
                    src="https://ssv-website.oss-cn-shenzhen.aliyuncs.com/mainland/image/1661175934596_5.png"></el-image>
              </div>
              <div class="name">邢起</div>
              <div class="desc">常务副总裁</div>
              <div class="content">
                中国创新创业大赛总冠军<br>
                天津市科技进步一等奖<br>
                宁波高层次人才<br>
                V.True原创始人<br>
                打造了宁波3D产业链<br>
                九拼屏裸眼3D总规划师
              </div>
            </div>
          </div>
          <div class="span"></div>
        </div>
      </div>

      <div class="partner" id="partner">
        <div class="title">
          <span>合作伙伴</span></div>
        <partnerComponents></partnerComponents>
      </div>

      <div class="connect" id="connect">
        <div class="title">
          <span>联系我们</span></div>
        <div class="address-list">
          <div class="item">
            <div class="top">
              <div class="icon">
                <el-image :src="require('@/assets/slices/icon_office.png')"></el-image>
              </div>
              <div class="name">办公地址</div>
            </div>
            <div class="address">深圳市福田区滨河大道9289号京基滨河时代大厦A座4403B</div>
          </div>
          <div class="item">
            <div class="top">
              <div class="icon">
                <el-image :src="require('@/assets/slices/icon_factory.png')"></el-image>
              </div>
              <div class="name">工厂地址</div>
            </div>
            <div class="address">广东省深圳市宝安区石岩外环路三江名创科技园A栋5楼</div>
          </div>
          <div class="item">
            <div class="top">
              <div class="icon">
                <el-image :src="require('@/assets/slices/icon_contact.png')"></el-image>
              </div>
              <div class="name">联系方式</div>
            </div>
            <div class="address"> info@e3d-meta.com<span></span> +86-15986834309</div>
          </div>
        </div>


        <div class="map">
          <baidu-map :center="{lng:113.95910834387207, lat:22.6648521280445}" :zoom="zoom" @ready="handler"
                     :scroll-wheel-zoom='true' class="map">
            <template v-for="item in points">
              <bm-marker :position="item"
                         :icon="{url: require('@/assets/slices/position.png'), size: {width: 32, height: 52}}">
              </bm-marker>
            </template>
          </baidu-map>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import layoutHeader from '@/components/layout/header'
import partnerComponents from '@/components/partner'
import Swiper from 'swiper';
import 'swiper/dist/css/swiper.min.css';
import BaiduMap from 'vue-baidu-map/components/map/Map.vue'
import BmPointCollection from 'vue-baidu-map/components/overlays/PointCollection.vue'

export default {
  components: {
    layoutHeader,
    partnerComponents,
    BaiduMap,
    BmPointCollection
  },
  name: 'layout',
  data() {
    return {
      tabList: [
        {name: '公司介绍', id: "company", top: 0},
        {name: '荣誉资质', id: "honor", top: 0},
        {name: '核心团队', id: "team", top: 0},
        {name: '合作伙伴', id: "partner", top: 0},
        {name: '联系我们', id: "connect", top: 0},
      ],
      tabFixed: false,
      tabIndex: 0,
      nowId: '',
      points: [
        {lng: 114.011291, lat: 22.600112},
        {lng: 113.918676, lat: 22.735109},
      ],
      center: {lng: 0, lat: 0},
      zoom: 10,
      tabTop: 0,
      tabHeight: 0,
      headerHeight: 0,
    }
  },
  created() {
  },
  mounted() {
    window.addEventListener("scroll", this.scrollToTop, true);
    this.initSwiper()
    this.$nextTick(function () {

      this.headerHeight = document.getElementById("headerBox").offsetHeight
      this.tabTop = document.getElementById("aboutTab").offsetTop
      this.tabHeight = document.getElementById("aboutTab").offsetHeight

      this.tabList.forEach(item => {
        item.top = document.getElementById(item.id).offsetTop - this.headerHeight - this.tabHeight
      })
      if (this.$route.query.index) {
        this.lookUp(this.$route.query.index, true)
      }
    })
  },
  watch: {
    '$route'(val, from) {//监听到路由（参数）改变
      // 拿到目标参数 val.query.typeCode 去再次请求数据接口
      setTimeout(() => {
        this.lookUp(val.query.index, true)
      }, 100)
    }
  },
  methods: {
    scrollToTop() {
      let that = this;
      that.tabFixed = window.pageYOffset > this.tabTop - this.headerHeight;
      for (let i = this.tabList.length - 1; i >= 0; i--) {
        const item = this.tabList[i]
        if (window.pageYOffset >= item.top) {
          this.tabIndex = i
          break;
        }
      }

    },
    handler({BMap, map}) {
      this.center.lng = 113.95910834387207
      this.center.lat = 22.6648521280445
      this.zoom = 13
    },
    lookUp(index, addTab = false) {
      index = parseInt(index)
      const item = this.tabList[index]
      const top = item.top
      window.scrollTo({
        top: top,
        behavior: 'smooth'
      })
    },
    initSwiper() {
      var mySwiper = new Swiper('#topSwiper', {
        slidesPerView: 5,
        spaceBetween: 30,
        loop: true,
        speed: 3000,
        autoplay: {
          delay: 0,
          reverseDirection: true,
          disableOnInteraction: false,
        },
        autoplayDisableOnInteraction: false,
        freeMode: true,
      })

      var mySwiper = new Swiper('#bottomSwiper', {
        slidesPerView: 5,
        spaceBetween: 30,
        loop: true,
        speed: 3000,
        autoplay: {
          delay: 0,
          disableOnInteraction: false,
        },
        autoplayDisableOnInteraction: false,
        freeMode: true,
      })
    },
  }
}
</script>

<style lang="scss" scoped>
.swiper-container-free-mode > .swiper-wrapper {
  -webkit-transition-timing-function: linear; /*之前是ease-out*/
  -moz-transition-timing-function: linear;
  -ms-transition-timing-function: linear;
  -o-transition-timing-function: linear;
  transition-timing-function: linear;
  margin: 0 auto;
}

.map-view {
  width: 100%;
  height: 800px;
}

.about {
  background: #141414;

  .header-box {
    top: 0;
    left: 0;
    width: 100%;
    position: fixed;
    z-index: 100;
  }

  .content {
    color: #fff;

    > .title {
      height: 482px;
      color: #fff;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      background: url('https://ssv-website.oss-cn-shenzhen.aliyuncs.com/mainland/image/1661418296219220888.png') no-repeat center center;
      background-size: cover;
    }


    .tab {
      line-height: 60px;
      display: flex;
      justify-content: center;
      padding: 0 40px;
      box-sizing: border-box;

      .main-container {
        display: flex;
        align-items: center;
        border-bottom: 1px solid #EDEDED;
      }

      .item {
        margin-right: 144px;
        font-size: 24px;
        color: rgba(255, 255, 255, 0.8);
        cursor: pointer;
      }

      .item.active {
        font-size: 30px;
        font-weight: 500;
        color: #EB6100;
        border-bottom: 7px solid #EB6100;
      }
    }

    .tab-fixed {
      position: fixed;
      top: 80px;
      left: 0;
      width: 100%;
      background: #141414;
      z-index: 90;
    }

    .company {
      padding-top: 144px;
      display: flex;

      .left {
        width: 805px;
        height: 457px;
        margin-right: 30px;

        .el-image {
          width: 805px;
          height: 457px;
        }
      }

      .right {
        text-align: left;
        flex: 1;
        padding-right: 50px;

        .title {
          line-height: 60px;
          font-size: 40px;
          font-weight: 500;
          color: #FFFFFF;

          span {
            line-height: 60px;
            border-bottom: 6px solid #EB6100;
          }
        }

        .desc {
          margin-top: 30px;
          font-size: 20px;
          line-height: 28px;
          color: rgba(255, 255, 255, 0.7);
        }

        .detail {
          margin-top: 30px;
          font-size: 24px;
          line-height: 34px;
        }
      }
    }

    .honor {
      padding-top: 130px;

      .title {
        text-align: left;
        line-height: 60px;
        font-size: 40px;
        font-weight: 500;
        color: #FFFFFF;
        padding-left: 120px;

        span {
          border-bottom: 6px solid #EB6100;
        }
      }

      .list {
        background: rgba(91, 91, 91, 0.9);
        padding: 37px 40px 21px 40px;

        .swiper {
          width: 100%;

          .swiper-slide {
            height: 367px;
            background: #fff;
            text-align: center;

            img {
              height: 367px;
              max-height: 367px;
              max-width: 100%;
            }
          }
        }
      }

      .list.top {
        margin-right: 90px;
        margin-top: 46px;
      }

      .list.bottom {
        margin-left: 90px;
        margin-top: 38px;
      }
    }

    .team {
      padding-top: 130px;

      .title {
        text-align: center;
        line-height: 60px;
        font-size: 40px;
        font-weight: 500;
        color: #FFFFFF;
        margin-bottom: 115px;

        span {
          border-bottom: 6px solid #EB6100;
        }
      }

      .bottom-list {
        margin-top: 110px;

        .item-container {
          flex: 7;
        }

        .span {
          flex: 2;
        }
      }

      .list {
        display: flex;
        align-items: stretch;

        .item-container.ceo {
          margin-top: 0;
          flex: 8;
        }

        .item-container {
          flex: 7;

          .span {
            height: 193px;
          }
        }

        .item {
          background: #5C5C5C;
          box-shadow: 0px 11px 22px 0px rgba(0, 0, 0, 0.1);
          border-radius: 12px;
          border: 2px solid #FFFFFF;
          font-size: 22px;
          padding: 34px;
          box-sizing: border-box;
          margin: 0 40px 0;
          font-family: PingFang SC-Regular, PingFang SC;
          min-height: 619px;


          .avatar {
            text-align: center;

            .el-image {

              width: 240px;
              height: 240px;
              border-radius: 50%;
            }
          }

          .name {
            font-size: 24px;
            font-weight: 500;
            text-align: center;
            margin-bottom: 10px;
            line-height: 28px;
            margin-top: 9px;
          }

          .desc {
            text-align: center;
            margin-bottom: 10px;
            line-height: 26px;
            margin-top: 4px;
          }

          .content {
            line-height: 30px;

            .sub-title {
              color: #8d8d8d;
            }

            .sub-info {
              display: flex;

              div {
                &:first-child {
                  flex: 1;
                }

                &:last-child {
                  width: 180px;
                  text-align: left;
                }
              }
            }
          }
        }

        .ceo .item {
          min-height: 702px;
        }
      }
    }

    .partner {
      padding: 130px 125px 0 144px;

      .title {
        text-align: center;
        line-height: 60px;
        font-size: 40px;
        font-weight: 500;
        color: #FFFFFF;
        margin-bottom: 120px;

        span {
          border-bottom: 6px solid #EB6100;
        }
      }

      .info {
        height: 700px;
        border: 1px solid #fff;
      }
    }

    .connect {
      padding: 130px 125px 90px 144px;

      .title {
        text-align: center;
        line-height: 60px;
        font-size: 40px;
        font-weight: 500;
        color: #FFFFFF;

        span {
          border-bottom: 6px solid #EB6100;
        }
      }

      .address-list {
        font-size: 16px;
        display: flex;
        justify-content: space-between;
        margin-top: 75px;
        margin-bottom: 43px;
        align-items: stretch;

        .item {
          padding: 26px 35px;
          border: 1px solid #fff;
          border-radius: 6px;
          text-align: left;
          flex: 1;

          &:first-child {
            margin-right: 20px;
          }

          &:last-child {
            margin-left: 20px;
          }

          .top {
            display: flex;
            align-items: center;
            margin-bottom: 28px;

            .icon {
              width: 21px;
              height: 21px;
              margin-right: 5px;
            }

            .name {

            }
          }

          .address {
            line-height: 19px;

            span {
              display: inline-block;
              width: 40px;
            }
          }
        }
      }

      .map {
        height: 800px;
        background: #fff;
      }
    }
  }
}
</style>
